export default __webpack_public_path__ + "static/media/manual_buscador_normativo.798e45e9.pdf";